import { ApiTag } from '@/enum/apiTag'
import { InteractionRequiredAuthError } from '@azure/msal-browser'
import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react'
import { loginRequest } from '../../services/msalConfig'
import { msalInstance } from '../../services/msalInstance'

const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_API_BASE_URL,
})

// Helper to get access token (silent or popup fallback)
async function getAccessToken(activeAccount: any) {
  const accessTokenRequest = { ...loginRequest, account: activeAccount }
  try {
    const response = await msalInstance.acquireTokenSilent(accessTokenRequest)
    return response.accessToken
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      const response = await msalInstance.acquireTokenPopup(accessTokenRequest)
      return response.accessToken
    }
    throw error
  }
}

// Enhanced baseQuery with automatic re-auth
const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  unknown
> = async (args, api, extraOptions) => {
  try {
    const modifiedArgs: FetchArgs & { skipAuth?: boolean } =
      typeof args === 'string' ? { url: args } : { ...args }

    if (!modifiedArgs.skipAuth) {
      const activeAccount = msalInstance.getActiveAccount()

      if (activeAccount) {
        const token = await getAccessToken(activeAccount)
        modifiedArgs.headers = {
          ...(modifiedArgs.headers || {}),
          Authorization: `Bearer ${token}`,
        }
      }
    }

    return await baseQuery(modifiedArgs, api, extraOptions)
  } catch (error) {
    console.error('API authentication error:', error)
    return { error }
  }
}

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
  tagTypes: Object.values(ApiTag),
})
